import { Const as SharedConst } from '@rt/shared/src';

const _Const = SharedConst();
export const Const = {
  ..._Const,
  Gcloud: {
    ..._Const.Gcloud,
    LocalConfigurationName: 'troppus-local',
  },
  Postgres: {
    Database: 'troppus',
    LocalCredentials: {
      User: 'admin',
      Pass: 'admin',
    },
  },
};
